module.exports = __webpack_public_path__ + "img/icon-close.5ece5c70.svg";